import * as React from 'react';
import { Calendar } from './Calendar';
import { TPAComponentsConsumer } from '../TPAComponentsConfig';
import { st, classes } from './DatePicker.st.css';
import { DATA_HOOKS } from './constants';
import type { DatePickerProps, DatePickerDefaultProps } from './types';

/** The DatePicker allows a user to select a specific date. */
export class DatePicker extends React.Component<DatePickerProps> {
  static displayName = 'DatePicker';
  static defaultProps: DatePickerDefaultProps = {
    locale: 'en-US',
    excludePastDates: false,
    filterDate: () => true,
    showMonthDropdown: false,
    showYearDropdown: false,
    dateIndication: (_: { date: Date; isSelected: boolean }) => null,
    fixedWeeks: true,
    showOutsideDays: true,
  };

  render() {
    const {
      className,
      value,
      onChange,
      onMonthChange,
      locale,
      excludePastDates,
      filterDate,
      firstDayOfWeek,
      showMonthDropdown,
      showYearDropdown,
      dateIndication,
      today,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      leftArrowAriaLabel,
      leftArrowAriaLabelledBy,
      rightArrowAriaLabel,
      rightArrowAriaLabelledBy,
      monthDropdownAriaLabel,
      monthDropdownAriaLabelledBy,
      yearDropdownAriaLabel,
      yearDropdownAriaLabelledBy,
      removeOuterPadding,
      showOutsideDays,
      fixedWeeks,
    } = this.props;

    return (
      <TPAComponentsConsumer>
        {({ rtl }) => (
          <div
            className={st(classes.root, className)}
            data-hook={this.props['data-hook']}
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledBy}
            role="region"
          >
            <Calendar
              showOutsideDays={showOutsideDays}
              className={st(classes.calendar, { removeOuterPadding })}
              dataHook={DATA_HOOKS.CALENDAR}
              value={value}
              onChange={(selectedDays) => onChange(selectedDays as Date)}
              onMonthChange={onMonthChange}
              locale={locale}
              excludePastDates={excludePastDates}
              filterDate={filterDate}
              firstDayOfWeek={firstDayOfWeek}
              showMonthDropdown={showMonthDropdown}
              showYearDropdown={showYearDropdown}
              rtl={rtl}
              numOfMonths={1}
              autoFocus={false}
              dateIndication={dateIndication}
              leftArrowAriaLabel={leftArrowAriaLabel}
              leftArrowAriaLabelledBy={leftArrowAriaLabelledBy}
              rightArrowAriaLabel={rightArrowAriaLabel}
              rightArrowAriaLabelledBy={rightArrowAriaLabelledBy}
              monthDropdownAriaLabel={monthDropdownAriaLabel}
              monthDropdownAriaLabelledBy={monthDropdownAriaLabelledBy}
              yearDropdownAriaLabel={yearDropdownAriaLabel}
              yearDropdownAriaLabelledBy={yearDropdownAriaLabelledBy}
              today={today}
              fixedWeeks={fixedWeeks}
            />
          </div>
        )}
      </TPAComponentsConsumer>
    );
  }
}
